export default __webpack_public_path__ + "static/media/pathname_script.931af0a8.gif";